import { createTheme, ThemeProvider } from '@mui/material/styles'
import React, { useEffect } from 'react'
import ReactGA from 'react-ga4'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Navigate, Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import Bookings from '../src/pages/Bookings/Bookings'
import { PrivateRoute } from './components'
import { BookingSuccessful, Candidates, Login, OTPVerification, PageNotFound, Profile, Register } from './pages'
import BookingById from './pages/Bookings/components/BookingById'
import CreateBookings from './pages/Bookings/components/CreateBookings'
import { SnackbarProvider } from './providers/SnackbarProvider'
import { BOOKING_ROUTE, CREATE_BOOKING_ROUTE } from './routes'
import './styles.css'

const initializeGa = () => {
    const gaCode = process.env.REACT_APP_GA_TRACKING_CODE
    const pathname = window.location.pathname + window.location.search
    ReactGA.initialize(gaCode)
    ReactGA.send({ hitType: 'pageview', page: pathname })
}

const theme = createTheme({
    palette: {
        primary: {
            main: '#244CB3',
            contrastText: '#fff',
            light: '#244CB3ef',
        },
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                input: {
                    padding: 0,
                },
                root: {
                    padding: 14,
                },
            },
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0,
                variant: 'outlined',
            },
        },
        MuiButton: {
            defaultProps: {
                variant: 'outlined',
            },
        },
    },
    typography: {},
})

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
})

export const App = () => {
    useEffect(() => {
        initializeGa()
    })

    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
                <SnackbarProvider>
                    <div className="App">
                        {/* <Header /> */}
                        <Routes>
                            <Route path="/" element={<Navigate to={BOOKING_ROUTE} />} />
                            s
                            <Route path="/register" element={<Register />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/otpverification" element={<OTPVerification />} />
                            <Route
                                path={BOOKING_ROUTE}
                                element={
                                    <PrivateRoute>
                                        <Bookings />
                                    </PrivateRoute>
                                }
                            />
                            {/* this is for test */}
                            <Route
                                path={CREATE_BOOKING_ROUTE}
                                element={
                                    <PrivateRoute>
                                        <CreateBookings />
                                    </PrivateRoute>
                                }
                            />
                            <Route
                                path="/bookings/:bookingId"
                                element={
                                    <PrivateRoute>
                                        <BookingById />
                                    </PrivateRoute>
                                }
                            />
                            {/* end test route */}
                            <Route path="/create-booking" element={<Navigate to={CREATE_BOOKING_ROUTE} />} />
                            <Route
                                path="/booking-success"
                                element={
                                    <PrivateRoute>
                                        <BookingSuccessful />
                                    </PrivateRoute>
                                }
                            />
                            <Route
                                path=":bookingId/workers/:status"
                                element={
                                    <PrivateRoute>
                                        <Candidates />
                                    </PrivateRoute>
                                }
                            />
                            <Route
                                path="/profile/:workerId/:bookingId"
                                element={
                                    <PrivateRoute>
                                        <Profile />
                                    </PrivateRoute>
                                }
                            />
                            <Route path="/*" element={<PageNotFound />} />
                        </Routes>
                        {/* {location.pathname === "/" && (
            <div className={classes.myBookingsFooter}>
              <CreateBookingButton />
            </div>
          )} */}
                        <ToastContainer style={{ width: '600px', maxWidth: '100%' }} />
                    </div>
                </SnackbarProvider>
            </ThemeProvider>
        </QueryClientProvider>
    )
}
